import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const OutlinedBox = styled(Box)(({ theme }) => ({
  //boxShadow: "rgba(200, 200, 200, 0.4) 0px 1px 8px 0px", 
  borderRadius: 8, 
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${theme.palette.divider}`,
}));

export default OutlinedBox;